import { motion } from "framer-motion";

const credenziali = [
  {
    year: "2006",
    title: "Laurea in Medicina e Chirurgia",
    place: "Università degli Studi di Pavia",
  },
  {
    year: "2011",
    title: "Specializzazione in Ematologia",
    place: "Università degli Studi di Pavia",
  },
  {
    year: "Oggi",
    title: "Medico ematologo",
    place: "Fondazione IRCCS Policlinico San Matteo",
  },
];

export default function ChiSono() {
  return (
    <section
      id="chi-sono"
      data-testid="chi-sono-section"
      className="py-24 md:py-32 bg-[#F9F8F6]"
    >
      <div className="max-w-[1320px] mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4">
          <p className="eyebrow">01 — Chi Sono</p>
          <h2 className="font-serif-display text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight mt-6 text-[#1A1D1A]">
            Una medicina fatta di{" "}
            <span className="italic text-[#8A6D56]">tempo</span> e di dati clinici solidi.
          </h2>
        </div>

        <div className="lg:col-span-8 lg:pl-8">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="text-lg leading-relaxed text-[#1A1D1A]/85 max-w-[640px]"
          >
            Da oltre quindici anni mi occupo di ematologia clinica, con particolare attenzione
            alla diagnosi di problematiche ematologiche benigne e maligne. Ogni visita è un
            percorso: valuto la storia del paziente, integro gli esami e propongo un piano
            terapeutico chiaro.
          </motion.p>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="text-base leading-relaxed text-[#5C635E] mt-6 max-w-[640px]"
          >
            Ricevo presso la Fondazione IRCCS Policlinico San Matteo di Pavia e presso lo
            Studio Viqueria a Voghera, con l&apos;obiettivo di offrire continuità di cura
            in un territorio che conosco bene.
          </motion.p>

          {/* Timeline */}
          <div className="mt-14 border-t border-[#E5E1D8]">
            {credenziali.map((c, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 12 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.06 }}
                className="grid grid-cols-12 gap-6 py-6 border-b border-[#E5E1D8] group"
              >
                <div className="col-span-3 md:col-span-2">
                  <p className="font-serif-display text-2xl text-[#8A6D56]">{c.year}</p>
                </div>
                <div className="col-span-9 md:col-span-10">
                  <p className="text-[15px] font-semibold text-[#1A1D1A]">{c.title}</p>
                  <p className="text-sm text-[#5C635E] mt-1">{c.place}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
